/**
 * 초대 링크 회원가입 페이지
 * /invite?token=xxx 에서 접근
 */
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from '../components/ui';
import { authApi } from '../api';
import './LoginPage.css';

export function InviteRegisterPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showToast } = useToast();
  const token = searchParams.get('token') || '';

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [tokenError, setTokenError] = useState('');

  useEffect(() => {
    if (!token) { setTokenError('초대 링크가 유효하지 않습니다.'); return; }
    authApi.getInviteInfo(token)
      .then((info) => setEmail(info.email))
      .catch(() => setTokenError('유효하지 않거나 만료된 초대 링크입니다.'));
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) { showToast('error', '이름을 입력해주세요.'); return; }
    if (password.length < 6) { showToast('error', '비밀번호는 6자 이상이어야 합니다.'); return; }
    if (password !== passwordConfirm) { showToast('error', '비밀번호가 일치하지 않습니다.'); return; }
    try {
      setLoading(true);
      await authApi.inviteRegister(token, name.trim(), password);
      showToast('success', '회원가입이 완료되었습니다. 로그인해주세요.');
      navigate('/login');
    } catch (e) {
      showToast('error', (e as any)?.response?.data?.error?.message || '회원가입에 실패했습니다.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-stage">
      <div className="login-card">
        <div className="login-brand">
          <h1 className="login-logo">
            <img src="/logo-acxionon-admin.svg" alt="Acxion-On" />
          </h1>
          <p>회원가입 초대</p>
        </div>

        {tokenError ? (
          <div style={{ color: '#e5484d', textAlign: 'center', fontSize: 14 }}>{tokenError}</div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label>이메일</label>
              <input type="email" value={email} disabled style={{ background: '#f5f5f8', color: '#888' }} />
            </div>
            <div className="login-field">
              <label>이름</label>
              <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="이름 입력" autoComplete="name" />
            </div>
            <div className="login-field">
              <label>비밀번호</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="비밀번호 (6자 이상)" autoComplete="new-password" />
            </div>
            <div className="login-field">
              <label>비밀번호 확인</label>
              <input type="password" value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)} placeholder="비밀번호 확인" autoComplete="new-password" />
            </div>
            <button type="submit" className="login-submit" disabled={loading || !email}>
              {loading ? '처리 중...' : '회원가입'}
            </button>
          </form>
        )}

        <p className="login-alt">
          <button type="button" onClick={() => navigate('/login')} style={{ color: '#8a8a96', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13 }}>
            로그인으로 돌아가기
          </button>
        </p>
      </div>
      <div className="login-foot">
        <img className="login-etech" src="/logo-etech.svg" alt="ETECH SYSTEM" />
      </div>
    </div>
  );
}

export default InviteRegisterPage;
